import { render } from "./PaymentError.vue?vue&type=template&id=2c96be3b&scoped=true"
const script = {}

import "./PaymentError.vue?vue&type=style&index=0&id=2c96be3b&scoped=true&lang=css"

import exportComponent from "/data03/virt76591/domeenid/www.kuulsaal.ee/bookings-frontend/git/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c96be3b"]])

export default __exports__